import { config } from "../../config";
import { BookWithStats, StatusEnum } from "./data-types";

type ChangeStatusResult = {
    book?: BookWithStats
    error?: string
}


export const changeBookStatus = async (isbn13: string, status_id: StatusEnum, isbn_db: boolean, token: string, force?: boolean): Promise<ChangeStatusResult> => {
    try {
        const authHeaders: {[key: string]: string} = {}
        if (token) {
            authHeaders['token'] = token
        }

        const url = force ? '/book/follow/' : '/book/change-status/'
        const method = force ? 'POST' : 'PATCH'

        const res = await fetch(`${config.api.urlV1}${url}`, {
            method,
            headers: {
                ...authHeaders,
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                isbn13,
                status_id,
                isbn_db,
            })
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.error?.title
            }
        }

        const body: BookWithStats = await res.json()

        return {
            book: body,
        }
    } catch (e) {
        return {
            error: e as string
        }
    }
}